import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { PlazosService } from "../../../services/plazos.service";
import { CreditosService } from "../../../services/creditos.service";
import { VerdesService } from '../../../services/creditos/verdes.service';
import { ConveniosService } from '../../../services/convenios.service';

@Component({
  selector: 'verde-simulador',
  templateUrl: './verde-simulador.component.html',
  styleUrls: ['./verde-simulador.component.scss']
})

export class VerdeSimuladorComponent implements OnInit {
  //Constants
  private tipoCredito = 4;
  //UI
  public cliente: any = {};
  public prestamo: any = {};
  public verde: any = {};
  public plazos: any = [];
  public plazoSelected: any = '';
  public catalogoPeriodicidad: any = {};
  public catalogoTipoCalculo: any = {};
  public errors: any = {};
  //Subscriptions
  private sub: any;
  //Edit mode
  private id: number = null;
  //Selección de convenio
  public convenioDefault = "";
  public convenioSelected: any = { id: null };
  public optConvenios = []

  constructor(
    private helperService: HelpersService,
    public location: Location,
    private plazosService: PlazosService,
    private creditosService: CreditosService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private verdesService: VerdesService,
    private conveniosService: ConveniosService
  ) {
  }

  public ngOnInit() {
    this.setDefaultValues();
    this.getConvenios();
    this.getPlazos();
    this.sub = this.activeRoute.params.subscribe(params => {
      if (params['id']) {
        //Edit mode
        this.id = params['id'] ? +params['id'] : 0; // (+) converts string 'id' to a number
        this.getCredito(this.id);
      }
    });
  }

   public getConvenios(){
      // let filters = this.getActiveFilters();
  
      this.conveniosService.getAll({tipo:"Verde"}).subscribe(
        (response)=>
        {
          let respuesta = response.json().content;
          console.log(respuesta);
          if (respuesta.length > 1){
            this.optConvenios = respuesta;
            this.convenioDefault = "Sin convenio";
          }else{
            this.optConvenios = respuesta;
            this.convenioDefault = "Sin convenio";
            this.prestamo.idConvenio = null;
          }
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }
    

  convenioChanged(tipo) {
    console.log("Event convenio: ", tipo);

    if (tipo.id) {
      this.convenioSelected = tipo;
      this.prestamo.periodicidad = this.convenioSelected.periodicidad;
      this.prestamo.idConvenio = this.convenioSelected.id;
    } else {
      this.setDefaultValues();
    }
  }

  private selectConvenio(idConvenio: number | string) {
    if (!idConvenio || !this.optConvenios) {
      this.convenioSelected = null;
      return;
    }

    // 1. Find the object. Using == instead of === handles string/number mismatches safely.
    const convenioEncontrado = this.optConvenios.find(c => c.id == idConvenio);

    if (convenioEncontrado) {
      // 2. Assigning the reference for UI binding
      this.convenioSelected = convenioEncontrado;
    } else {
      this.convenioSelected = null;
      // Log for debugging if a loan has a convenio ID that doesn't exist in the catalog
      console.warn(`Convenio with ID ${idConvenio} not found in catalog.`);
    }
  }

  private setDefaultValues() {
    this.prestamo.calculo = 1;//Default crédito insoluto
    this.prestamo.periodicidad = 2;//Periodicidad Mensual
    this.catalogoPeriodicidad = this.creditosService.getCatalogoPeriodicidad();
  }

  private getCredito(idCredito: number) {

    //TODO: Manejar cuando el id no retorna un crédito valido
    this.verdesService.get(idCredito).subscribe(
      (response) => {
        const result = response.json().content;
        this.prestamo = result.credito.prestamo;
        this.selectConvenio(result.credito.idConvenio);
        this.cliente = result.credito.cliente;
        this.verde = result.verde;
        this.selectPlazo(result.credito.prestamo);
      }, error => {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if (error.status == 400) {
          this.helperService.showSaveCreditErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getPlazos() {
    this.plazosService.getAll(this.tipoCredito).subscribe(
      (response) => {
        this.plazos = response.json().content;
      }, error => {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if (error.status == 400) {
          this.helperService.showSaveCreditErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public save() {
    this.errors = {};

    let credito = {
      idCreditos: null,
      prestamo: this.prestamo,
      cliente: null,
      verde: this.verde
    };

    if (typeof this.cliente.email === 'object') {
      //Cuando se selecciono un usuario con Typeahead, 
      //el modelo cliente.email tiene asociado un objeto con todos los datos del cliente
      let clienteToSave = {
        email: this.cliente.email.email,
        nombre: this.cliente.nombre,
        //Cuando es un update el modelo this.cliente tiene todos los datos del cliente
        //En el caso del create en el modelo this.cliente.email Typeahead pone el JSON completo del Cliente
        id: (this.cliente.id ? this.cliente.id : this.cliente.email.id)
      };
      credito.cliente = clienteToSave;
    } else {
      //Caso cuando el email se ingreso de forma manual
      credito.cliente = this.cliente;
    }

    //El plazo seleccionado esta en el modelo plazoSelected, se debe actualizar el valor en el modelo que se enviará al servicio
    if (this.plazoSelected) {
      //Default solo para pruebas
      credito.prestamo.plazo_periodo = this.plazoSelected.periodo;
      credito.prestamo.plazo_medida = this.plazoSelected.medida;
    }

    this.errors = this.verdesService.validate(credito);

    if (Object.entries(this.errors).length > 0) {
      return false;
    }

    if (this.id) {
      //Update credito
      //set idCreditos
      credito.idCreditos = this.id;
      this.update(credito);
    } else {
      //New credito
      this.create(credito);
    }
  }

  private create(credito: any) {
    this.verdesService.save(credito).subscribe(
      (response) => {
        const result = response.json().content;
        //Navigate to tabla de amortizacion
        this.router.navigate(['/creditos/tabla-amortizacion/', result.id]);
      }, error => {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if (error.status == 400) {
          this.helperService.showSaveCreditErrors(error.json().content, this.errors);
        }
      }
    );
  }

  private update(credito: any) {
    this.verdesService.update(credito).subscribe(
      (response) => {
        const result = response.json().content;
        //Navigate to tabla de amortizacion
        this.router.navigate(['/creditos/tabla-amortizacion/', this.id]);
      }, error => {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if (error.status == 400) {
          this.helperService.showSaveCreditErrors(error.json().content, this.errors);
        }
      }
    );
  }

  public calculateMontoSolicitado() {
    if (this.verde.precio_equipo && this.verde.enganche) {
      this.prestamo.monto_prestamo = (this.verde.precio_equipo - this.verde.enganche);
    }
  }

  /**
   * Helpers
   */

  private selectPlazo(prestamo: any) {
    let selectedPlazo = null;
    this.plazos.forEach(function (element) {

      if (prestamo.plazo_periodo === element.periodo && prestamo.plazo_medida === element.medida) {
        selectedPlazo = element;
      }
    });

    if (selectedPlazo) {
      this.plazoSelected = selectedPlazo;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/creditos/verde/simulador/verde-simulador.component.ts